/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import Members from "./Members";
import LeftAccordionIcon from "@Assets/icons/Accordian.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getGroupDetailsUrl } from "@Services/utils/helpers";
import { getGroupData, type GroupRow } from "./groups.helper";

interface UsersInGroupProps {
  /**
   * Clears the parent's cached row when the tab changes (called with NO argument). Typed permissively
   * for the same reason as `Groups`: PortalSettings.tsx supplies a bare `useState()` setter.
   */
  setGroupData: (...args: never[]) => void;
  /** Always `undefined` in practice — PortalSettings.tsx's `useState()` state is typed `undefined`. */
  groupData?: GroupRow;
}

function UsersInGroup(props: UsersInGroupProps) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("members");
  const [groupData, setGroupData] = useState<GroupRow>({});
  const navigate = useNavigate();
  const changeActiveTab = (e: React.MouseEvent<HTMLElement>) => {
    setActiveTab((e.target as HTMLElement).id);
    props.setGroupData();
  };
  const paraGrpId = useParams();

  const handleBack = () => {
    navigate(getGroupDetailsUrl());
  };

  const init = async () => {
    const result = await getGroupData({
      value: {
        where: [
          {
            isComplex: false,
            field: "_id",
            operator: "equal",
            value: paraGrpId.costDatabaseId,
            ignoreCase: true,
            ignoreAccent: false,
          },
        ],
      },
    });
    if ((result as GroupRow[]).length) {
      setGroupData((result as GroupRow[])[0]!);
    }
  };

  useEffect(() => {
    if (props.groupData) {
      setGroupData(props.groupData);
    } else {
      init();
    }
  }, []);

  const header = () => (
    <div className="flex flex-col gap-2 ps-4 pb-2 w-full">
      <div className="flex gap-1 items-center">
        <img src={LeftAccordionIcon} onClick={handleBack} className="mt-1 cursor-pointer" />
        <span className="text-2xl font-semibold">{groupData.name}</span>
      </div>
      <div>
        <span className="text-sm">{groupData.description}</span>
      </div>
    </div>
  );

  const headerTabs = () => (
    <div className="flex h-[3.125rem] min-h-[3.125rem] items-end gap-[3.125rem] border border-s-0 bg-white ps-[1.875rem] text-sm [border-image-slice:1] [border-image-source:linear-gradient(92deg,#ecf3fe_30%,rgb(236_243_254_/_15%)_111%)]">
      <div className="flex w-fit flex-col items-center">
        <div
          id="members"
          className={`cursor-pointer text-center ${activeTab === "members" ? "mb-2.5" : "mb-3.5"}`}
          onClick={changeActiveTab}
        >
          {t("Members")}
        </div>
        {activeTab === "members" && (
          <div className="h-1 w-[calc(100%+0.625rem)] min-w-max rounded-md bg-gradient-to-r from-[#6bbbe3] to-[#3e8ab0]" />
        )}
      </div>
      {/* <div className={css.barItems}>
        <div id="rules" className={`${css.eachTabs} ${activeTab === 'rules' ? css.externalTab : ''}`} onClick={changeActiveTab}>
          Rules
        </div>
        {activeTab === 'rules' && <div className={css.activeTab} />}
      </div> */}
    </div>
  );

  return (
    <div className="flex h-full w-full flex-col bg-[#f0f5f9]">
      {groupData && header()}
      {headerTabs()}
      {activeTab === "members" && <Members />}
      {/* {activeTab === 'rules' && <Rules />} */}
    </div>
  );
}
export default UsersInGroup;
